<template>
  <div class="menu">
    <div class="title-block">
      <i class="fab fa-vuejs"></i>
      <h1>VUE DASHBOARD</h1>
    </div>
    <hr/>

    <router-link to="/dashboard">
    <i class="fas fa-chart-pie"></i>
      <h2>DASHBOARD</h2>
      </router-link>
    <router-link to="/tablelist">
    <i class="fas fa-scroll"></i>
      <h2>TABLE LIST</h2>
      </router-link>
    <router-link to="/userinfo">
    <i class="fas fa-user"></i>
      <h2>USER PROFILE</h2> 
      </router-link>
    <a href="" @click.prevent="logout">
    <i class="fas fa-sign-out-alt"></i>
      <h2>LOGOUT</h2>
    </a>

  </div>
</template>

<script>
  export default {
    methods: {
      logout(){
        localStorage.removeItem('token');
        this.$router.push('/login');
      }
    }
  }
</script>

<style scoped>
.menu{
  position:fixed;
  border-radius:4px;
  left:20px;
  top:80px;
  height: calc(100vh - 100px);
  width:230px;
  background-color: rgb(64,183,130);
  box-shadow: 10px 0 20px 2px rgba(0,0,0,.3);
}
.title-block{
  color:white;
  text-align:center;
  padding:20px 0;
}
.fa-vuejs{
  font-size:24px;
  padding:0 5px;
}
h1{
  font-weight:lighter;
  font-size:16px;
  display:inline-block;
}
h2{
  font-weight:normal;
  font-size:16px;
  display: inline-block;
  padding: 0 10px;
}
hr{
  width:80%;
  margin:auto;
  transform: scaleY(0.5);
  border-top:none;
  border-left:none;
}

.fas{
  font-size:16px;
}
a{
  display: block;
  font-size: 12px;
  color: rgba(255,255,255,.7);
  text-decoration: none;
  padding: 12px 40px 12px;
  margin:8px 0;
  box-sizing:border-box;
}
a:hover{
  color:white;
  transition:.3s;
  text-shadow: 3px 1px 3px #333;
}
a.router-link-active{
  color: white;
  transition:.3s;
  border-right:4px solid;
  text-shadow: 3px 1px 3px #333;
}

@media screen and (max-width:1024px){
  .menu{
    width:80px;
    transition:.3s;

  }
  .title-block h1,a h2{
    display: none;
  }
  a{
    padding: 12px 30px 12px;
    transition:.3s;
  }
}

@media screen and (max-width:480px){
  .menu{
    height: 60px;
    width: calc(100% - 40px);
    display: flex;
    justify-content: space-between;
    top:60px;
    z-index: 50;
  }
  .title-block,hr{
    display: none;
  }
  a.router-link-active{
    color: white;
    transition:.3s;
    border:none;
    text-shadow: 3px 1px 3px #333;
  }
}
</style>